// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./icons/Checkmark.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-page-style {
    width: 50vw
}

@media screen and (max-width: 768px) {
    .auth-page-style {
        width: 80vw;
    }
}

#auth-container {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    overflow: auto;
    position: fixed;
    background: #ffffff;
}

#auth-container.login #facebook-btn {
    position: relative;
    border-radius: 4px;
    background: #2960B1;
    text-transform: none;
    border-color: #2960B1;
}

#auth-container.login #facebook-btn:hover, #auth-container.login #facebook-btn:focus {
    background: #1f4a88;
    border-color: #1f4a88;
}

#auth-container.login #facebook-btn > .rubix-icon {
    top: 10px;
    left: 20px;
    font-size: 28px;
    position: absolute;
    vertical-align: top;
}

#auth-container.login #facebook-btn > .rubix-icon + span {
    font-size: 18px;
    padding-left: 20px;
    position: relative;
}

#auth-container.login a {
    color: #4A90E2;
    border-color: #4A90E2;
}

#auth-container.login a:hover, #auth-container.login a:focus {
    color: #4A90E2;
    border-color: #4A90E2;
}

#auth-container.signup #facebook-btn, #auth-container.signup #twitter-btn {
    position: relative;
    border-radius: 4px;
    text-transform: none;
}

#auth-container.signup #facebook-btn > .rubix-icon, #auth-container.signup #twitter-btn > .rubix-icon {
    top: 10px;
    left: 20px;
    font-size: 28px;
    position: absolute;
    vertical-align: top;
}

#auth-container.signup #facebook-btn > .rubix-icon + span, #auth-container.signup #twitter-btn > .rubix-icon + span {
    font-size: 18px;
    padding-left: 20px;
    position: relative;
}

#auth-container.signup #twitter-btn {
    background: #00ACDF;
    border-color: #00ACDF;
}

#auth-container.signup #twitter-btn:hover, #auth-container.signup #twitter-btn:focus {
    background: #0085ac;
    border-color: #0085ac;
}

#auth-container.signup #facebook-btn {
    background: #2960B1;
    border-color: #2960B1;
}

#auth-container.signup #facebook-btn:hover, #auth-container.signup #facebook-btn:focus {
    background: #1f4a88;
    border-color: #1f4a88;
}

#auth-container.signup a {
    color: #4A90E2;
    border-color: #4A90E2;
}

#auth-container.signup a:hover, #auth-container.signup a:focus {
    color: #4A90E2;
    border-color: #4A90E2;
}

.pending, .Pending, .Not-Started, .not-Started, .Not-Started, .not-Started {
    color: #f3901c;
}

.initiated, .Initiated, .invited, .Invited, .In-Progress, .in-Progress {
    color: #1c3ff3;
}

.Approved, .approved, .Not-Required, .not-Required, .Verified, .verified, .Completed, .completed {
    color: #05ce2f;
}

.Rejected, .rejected, .Canceled, .canceled {
    color: #ff0101;
}

.Waiting, .waiting {
    color: #f3901c;
}

.Going_to_Pick, .going-to-Pick {
    color: #1c3ff3;
}

.Arrived, .arrived {
    color: #1c3ff3;
}

.Picked, .picked {
    color: #05ce2f;
}

.Dropped, .dropped {
    color: #05ce2f;
}

.Not-Picked, .not-Picked {
    color: #ff0101;
}

.bg-Canceled, .bg-canceled {
    background-color: #ff0101 !important;
}

.bg-Completed, .bg-completed {
    background-color: #05ce2f !important;
}

.bg-In-Progress, .bg-in-Progress {
    background-color: #1c3ff3 !important;
}

.bg-Not-Started, .bg-not-Started {
    background-color: #f3901c !important;
}

.bg-In-Progress, .bg-in-Progress {
    background-color: #1c3ff3 !important;
}

/* start of global helper classes*/

.text-overflow {
    display: block !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.overflow-visible {
    overflow: visible !important;
}

.no-outline {
    outline: none !important;
}

.white-space-normal {
    white-space: normal !important;
}

/* end of global helper classes*/

/* start of global width/height classes*/

@media (min-width: 990px) {
    .max-full-width-minus-80 {
        max-width: calc(100% - 80px)
    }
}

.min-w-150 {
    min-width: 150px;
}



/* end of global width/height classes*/

/* start of global margin classes*/

.margin-b-15 {
    margin-bottom: 15px;
}

.mar-r-10 {
    margin-right: 10px;
}

/* end of global margin classes*/

/* start of global padding classes*/

.padding-r-0 {
    padding-right: 0 !important;
}

.padding-l-0 {
    padding-left: 0 !important;
}

/* end of global padding classes*/

/* start of global font classes*/

.font-bold {
    font-weight: bold;
}

.font-14 {
    font-size: 14px !important;
}

/* end of global font classes*/

.inline-content {
    display: inline-block;
}

.image-upload-label {
    position: absolute;
    width: 100%;
    height: 100%;
    font-weight: bold;
    bottom: 0;
    border-radius: 50%;
    overflow: hidden;
    margin: 0;
    top: 0;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
        justify-content: center;
    -ms-flex-align: center;
        align-items: center;
    background: rgba(255, 255, 255, .7);
    font-size: 50px;
}

.image-tag-container {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    bottom: 0;
    border-radius: 50%;
    overflow: hidden;
    margin: 0;
}

.image-verified-tag-container {
    color: green;
}

.image-verified-tag {
    background: white;
    opacity: .9;
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    min-height: 35px;
    line-height: 25px;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
        justify-content: center;
    font-size: 14px;
}

.camera-rubix-icon {
    font-size: 50px;
    color: gray;
    opacity: .5;
}

.profile-img-container {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    width: 150px;
    height: 150px;
    text-align: center;

    background: #e2e0e0;
    border-radius: 50%;
    -ms-flex-pack: center;
        justify-content: center;
    -ms-flex-align: center;
        align-items: center;
    display: -ms-flexbox;
    display: flex;
    overflow: hidden;
}

.display-image-user-driver {
    -o-object-fit: contain;
       object-fit: contain;
    height: 100%;
}

.rubix-panel-container, .rubix-panel {
    overflow: visible !important;
}

.loading-container {
    /* height: 100%; */
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    position: absolute;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
        justify-content: center;
    -ms-flex-align: center;
        align-items: center;
    z-index: 999999;
    background: #e6e6e6;
    opacity: 0.2;
}

.loading-container-correct {
    /* height: 100%; */
    height: 35%;
    width: 100%;
    /* top: 15%; */
    left: 0;
    right: 0;
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    position: absolute;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
        justify-content: center;
    -ms-flex-align: center;
        align-items: center;
    z-index: 999999;
    background: #e6e6e6;
    opacity: 0.2;
}

.patient-main-text {
    color: #333;
}

.btn-primary:focus, .btn-primary.focus {
    outline: none !important;
}

.home-containers .home-panel-bosy-count-height {
    min-height: 94px;
}

.home-containers .home-panel-body-user-request-height {
    min-height: 175px;
}

.home-containers .home-panel-body-patient-listing-height {
    min-height: 258px;
}

.home-containers .widget-block-panel-header {
    margin-top: 15px;
    margin-bottom: 15px;
}

.rubix-panel-container-with-bottom-shadow {
    -webkit-box-shadow: 3px 3px 10px rgba(0, 0, 0, .2);
            box-shadow: 3px 3px 10px rgba(0, 0, 0, .2);
}

.rubix-panel-container-with-bottom-shadow-overflow {
    overflow: hidden !important;
    -webkit-box-shadow: 3px 3px 10px rgba(0, 0, 0, .2);
            box-shadow: 3px 3px 10px rgba(0, 0, 0, .2);
}

.rubix-panel-container-with-bottom-shadow-inner {
    background: #FFFFFF;
    border: 2px solid #DADADA;
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
 }

 .rubix-panel-container-with-bottom-shadow-inner-selected {
    background: #FFFFFF;
    border: 2px solid #13E4A0;
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
    -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
 } 

 .radio-bottom-fixed {
    position: absolute;
    bottom: 0;
    right: 0;
    margin-right: 15px !important;
    margin-bottom: 10px !important;
 }

.radio-bottom-fixed:checked {
    width: 0px;
    right: 6.5%;
}

.checkbox-bottom-fixed {
    position: absolute;
    margin-top: 10px !important;
    right: 0;
    margin-right: 15px !important;
    margin-bottom: 10px !important;
 }

.checkbox-bottom-fixed:checked {
    width: 0px;
    right: 6.5%;
}

.checkbox-bottom-fixed:checked:after {
    width: 32px;
    height: 32px;
    border-radius: 30px;
    top: 0px;
    left: -1px;
    position: absolute;
    content: '';
    border: 2px solid #13E4A0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-color: white;
}

@media (max-width: 1024px){
    .radio-bottom-fixed:checked {
        width: 0px;
        right: 9.5%;
    }
    .checkbox-bottom-fixed:checked {
        width: 0px;
        right: 9.5%;
    }
}

@media (max-width: 900px){
    .radio-bottom-fixed:checked {
        width: 0px;
        right: 6.5%;
    }
    .checkbox-bottom-fixed:checked {
        width: 0px;
        right: 6.5%;
    }
}

@media (max-width: 700px){
    .radio-bottom-fixed:checked {
        width: 0px;
        right: 9.5%;
    }
    .checkbox-bottom-fixed:checked {
        width: 0px;
        right: 9.5%;
    }
}

.radio-bottom-fixed:checked:after {
    width: 32px;
    height: 32px;
    border-radius: 30px;
    top: 0px;
    left: -1px;
    position: absolute;
    content: '';
    border: 2px solid #13E4A0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-color: white;
}

.radio-bottom-fixed-multi {
    position: absolute;
    bottom: 0;
    right: 0;
    margin-right: 15px !important;
    margin-bottom: 10px !important;
 }

 .radio-bottom-fixed-multi:checked {
     width: 0px;
     right: 30px;
 }

.radio-bottom-fixed-multi:checked:after {
    width: 30px;
    height: 30px;
    border-radius: 30px;
    top: 0px;
    left: -1px;
    position: absolute;
    content: '';
    border: 2px solid #13E4A0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-color: white;
}

.checkbox-bottom-fixed-multi {
    position: absolute;
    margin-top: 10px !important;
    right: 0;
    margin-right: 15px !important;
    margin-bottom: 10px !important;
 }

 .checkbox-bottom-fixed-multi:checked {
     width: 0px;
     right: 30px;
 }

.checkbox-bottom-fixed-multi:checked:after {
    width: 30px;
    height: 30px;
    border-radius: 30px;
    top: 0px;
    left: -1px;
    position: absolute;
    content: '';
    border: 2px solid #13E4A0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-color: white;
}

 .textarea-radio {
     padding: 0;
     margin: -10px;
     border: none;
     width: 100%;
     color: #022144;
     font-size: 18px;
 }
 .textarea-modal {
    margin: -10px;
    /* border: none; */
    width: 100%;
    color: #022144;
    /* font-size: 18px; */
    resize: none;
}
.textarea-label-wrapper {
    border: 1px solid #079EDA;
    border-radius: 20px;
    margin-top: 10px;
    padding: 10px;
}
.textarea-label {
    font-size: 18px;
}

.comma:not(:first-child) {
    margin-left: -.3em;  
  }
  
  /* no need to display empty elements */
  .comma:empty {
    display: none;
  }
  
  .comma:not(:first-child):before {
    content: ", ";
  }

  .disability-block {
      width: 15%;
  }

  .sidebar-menu {
    height: 100px;
    bottom: 0;
    position: absolute;
    z-index: 999999999;
  }

  .sidebar-menu-nav > .container {
    width: 120px;
    padding: 0;
  }

  .sidebar-menu-nav .navbar-nav > li > a {
        padding: 0 !important;
    }

/* Custom scrollbar styles for popup content */
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}
 `, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
